/**
 * DesktopPickerOverlay - Inline dropdown picker for desktop screens
 *
 * Exports the View directly — click-outside dismissal is handled by the
 * parent toggling isPickerOpen via the + button press.
 */

export { default } from "./DesktopPickerOverlayView";
